import { GeneralInfoTabContent } from "@/entities/general-info-tab-content";
import { appRouterPaths } from "@/services/navigation";
import type { RouteProps } from "react-router-dom";

export const contactsGeneralInfoRouteV2: RouteProps = {
  path: appRouterPaths.contacts.genInfo,
  element: <GeneralInfoTabContent />,
};
